import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { agentDownloadRequest } from "../actions";
import { replaceHashValues } from "utils/replaceHashValues";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { checkAMLob } from "utils/checkAMLob";

import CommonHeader from "common-components/Header";
import { TitleLockup } from "@vds/type-lockups";
import Button from "common-components/Buttons";
import Container from "common-components/Container";
import Alert from "common-components/Alert";
import RectangleLoader from "common-components/RectangleLoader";
import { media, isMobile } from "utils/style";
import { agentSelectCustomer } from "../actions/agentSelectCustomer";


class AuthorizedAgentDownloadReview extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("review", this.props.pageContent.sc_pagetitle);
    }
  }

  submitDownload = () => {
    this.props.agentDownloadRequest().then(() => {
      if (!this.props.error) {
        this.props.history.push("success");
      }
    });
  };

  // checkNotificationMethod = (mdn, email) => {
  //   let notificationMethod = "";

  //   if (mdn && email) {
  //     notificationMethod = `${email}, and ${formatPhoneNumber(mdn)}`;
  //   } else if (mdn) {
  //     notificationMethod = formatPhoneNumber(mdn);
  //   } else {
  //     notificationMethod = email;
  //   }
  //   return notificationMethod;
  // };

  // renderNotificationMethod = () => {
  //   const { loggedInMdn, wlnMdn, accountEmail, accountOttEmail } = window.reactGlobals;

  //   if (checkAMLob() === "ott") {
  //     return this.checkNotificationMethod(loggedInMdn, accountOttEmail);
  //   } else if (checkAMLob() === "vzt") {
  //     return this.checkNotificationMethod(wlnMdn, accountEmail);
  //   }
  //   return this.checkNotificationMethod(loggedInMdn, accountEmail);
  // };
  renderCustomerIdentifier = () => {
    const {serviceType, mtn, accountId} = this.props.agentSelectedCustomer;
    if(serviceType &&  typeof serviceType  === "string"){
      if(serviceType.toLowerCase() === "vzt" ){
        return accountId;
      }
    }
    return formatPhoneNumber(mtn);
  };

  render() {
  
   
    if (!checkNestedObject(this.props, "pageContent", "section_title")) {
      return <Redirect to="/privacy/secure/authorized-agent" />;
    }
    // const { section_title, Category, buttons } = this.props;
    const { pageContent,loading, error } = this.props;
    // const { wlnAccountNumber } = window.reactGlobals;
    

    if (loading) {
     
      return <RectangleLoader id={"agentLoader"} />;
    }

    return (
      <Container>
        {error ? <Alert alertType="error">{this.props.error}</Alert> : null}

        <div style={{ maxWidth: "596px" }}>
        <TitleLockup
            surface='light'
            textAlignment='left'
            viewport={isMobile ? "mobile" : "desktop"}
            data={{
              title: {
                size: 'titleLarge',
                bold: false,
                children: convertStringToElements(pageContent.section_title)
              },
              subtitle: {
                size: 'bodyLarge',
                primitive: 'p',
                children: <Div>
                  <p data-qm-encrypt="true">
                  {convertStringToElements(
                    replaceHashValues(pageContent.Category[0].category_description, {
                      dateRangeSelected: this.props.downloadAmount.label,
                      deviceName: this.props.deviceName,
                      mdn: this.renderCustomerIdentifier()
                    })
                  )}
                  </p>
                  <ul>
                    {this.props.downloadCategories.map(item =>
                      item.checked ? <li key={item.category_id}>{item.category_name}</li> : null
                    )}
                  </ul>

                  {convertStringToElements(
                    replaceHashValues(pageContent.Category[0].category_sub_description, {
                      dateRangeSelected: this.props.downloadAmount.label,
                      notificationMethod: window.reactGlobals.agentInfo.agentEmailId
                    })
                  )}

                </Div>
              }

            }}


          />
          <ButtonContainer>
          <Button background={pageContent.buttons[0].type} style={{ marginTop: "16px" }} onClick={this.submitDownload}>
            {pageContent.buttons[0].text}
          </Button>
          <Button
              background={pageContent.buttons[1].type} style={{ marginTop: "16px" }}
              onClick={() => this.props.history.push("/privacy/secure/authorized-agent")}
            >
              {pageContent.buttons[1].text}
            </Button>
          </ButtonContainer>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({
  modalState,
  loadingAndErrorState,
  downloadInputInformation,
  pageContent,
  downloadAmount,
  agentSelectedCustomer
}) => ({
  showModal: modalState.showModal,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  downloadCategories: downloadInputInformation.downloadCategories,
  pageContent: pageContent.download_review,
  agentSelectedCustomer,
  modalContent: pageContent.download_success_modal,
  deviceName: agentSelectedCustomer.accountName,
  downloadAmount
});

export default connect(
  mapStateToProps,
  { setA11yContent, agentDownloadRequest, setBreadcrumbList }
)(AuthorizedAgentDownloadReview);

const Div = styled.div`
  margin: 40px 0;

  p {
    margin: 12px 0;
  }
`;
// const Header = styled(CommonHeader)`
//   max-width: 598px;
//   font-size: 48px;
//   line-height: 48px;
//   margin-bottom: 12px;
//   font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
//   font-weight: 300;

// ${media.mobile`
//   font-size: 32px;	
//   line-height: 36px;
//   font-weight: 300;
//   font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
// `}
// `;
const ButtonContainer = styled.div`
  display: flex;
  marginTop: "64px";
  ${media.mobile`
   flex-direction: column;
  `}
`;
